<div class="tag-list">
  @for (r of project.Profile.Requirements; track r) {
    @if (matchesPriority(r) && isVisible(r)) {
      <span class="tag d-inline-block requirement-tag bg-white clickable me-2 oneline" 
      [title]="r | requirementLabel : language"
      (click)="toggleSelect(r)" 
      [class.active]="r.isSelected" 
      [class.readonly]="readonly">
        @if (r.Priority == 'Core' && showCore) {
          <i class="fa-sharp fa-solid fa-star fa-xs me-2" style="opacity: .7;"></i>
        }
        {{ r | requirementLabel : language }}
      </span>
    }
  }
  @if (!readonly) {
    <div class="d-inline-block requirement-dropdown" ngbDropdown>
      <span ngbDropdownToggle class="tag d-inline-block requirement-tag bg-white clickable">
        <!-- <i class="fa-sharp fa-regular fa-plus"></i> --> +
      </span>
      <div ngbDropdownMenu>
        <a class="dropdown-item" (click)="add('Skill')">
          {{ texts.skill[language] }}
        </a>
        <a class="dropdown-item" (click)="add('Industry')">
          {{ texts.industry[language] }}
        </a>
        <a class="dropdown-item" (click)="add('Degree')">
          {{ texts.degree[language] }}
        </a>
        <a class="dropdown-item" (click)="add('Language')">
          {{ texts.language[language] }}
        </a>
        <a class="dropdown-item" [class.disabled]="hasExperienceRequirement()" (click)="add('Experience')">
          {{ texts.experience[language] }}
        </a>
        <a class="dropdown-item" (click)="add('Custom')">
          {{ texts.custom[language] }}
        </a>
      </div>
    </div>
  }
</div>
